const makeid = (length) => {
  const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
  const lowercase = "abcdefghijklmnopqrstuvwxyz"
  const numbers = "0123456789"
  const special = "*/#%@$_&-"

  let password = ""

  password += uppercase.charAt(Math.floor(Math.random() * uppercase.length))
  password += lowercase.charAt(Math.floor(Math.random() * lowercase.length))
  password += numbers.charAt(Math.floor(Math.random() * numbers.length))
  password += special.charAt(Math.floor(Math.random() * special.length))
  password += special.charAt(Math.floor(Math.random() * special.length))

  const allPossible = uppercase + lowercase + numbers + special
  for (let i = password.length; i < length; i++) {
    password += allPossible.charAt(Math.floor(Math.random() * allPossible.length))
  }

  password = password.split('').sort(() => 0.5 - Math.random()).join('')
  return password
}

export default makeid
